module.exports = __webpack_public_path__ + "static/media/05-check.b47f57a0.png";